<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
const favicon = require('@/assets/favicon.png');

export default {
  name: 'App',
};
</script>

<style>
html,
body {
  overflow: auto;
}
.material-icons.icon {
  display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// src/App.vue